import React from 'react';

import { appBridge, isWebViewEnvironment } from '../../services/bridge';

interface PdfButtonProps {
  /** 表示名（拡張子除去済みが望ましい） */
  name: string;
  /** PDF URL（未取得時は null / undefined）*/
  url: string | null | undefined;
  /** 閲覧済みフラグ */
  viewed: boolean;
  /** クリック時のコールバック（閲覧履歴更新など） */
  onView: () => void;
}

/**
 * PDF確認ボタン（共通コンポーネント）
 *
 * WebView 環境下では Flutter 側の `PdfViewerScreen` に URL を委譲して
 * アプリ内で PDF を表示する（URL を UI に表示しない要件）。
 * ブラウザ直接アクセス時は従来どおり `window.open` でタブを開く。
 */
export const PdfButton: React.FC<PdfButtonProps> = ({ name, url, viewed, onView }) => {
  if (!url) {
    return (
      <div className="pdf-check-button disabled">
        <img src="/assets/images/pdf.png" alt="PDFアイコン" className="pdf-icon" />
        <span className="pdf-button-text">{name}</span>
        <span className="pdf-unavailable">（準備中）</span>
      </div>
    );
  }

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    onView();
    if (isWebViewEnvironment()) {
      appBridge.openPdfViewer(url, name);
    } else {
      window.open(url, '_blank', 'noopener,noreferrer');
    }
  };

  return (
    <a
      href={url}
      rel="noopener noreferrer"
      className={`pdf-check-button ${viewed ? 'viewed' : ''}`}
      onClick={handleClick}
    >
      <img src="/assets/images/pdf.png" alt="PDFアイコン" className="pdf-icon" />
      <span className="pdf-button-text">{name}</span>
      {viewed && <span className="checkmark"></span>}
    </a>
  );
};
